import React from 'react';
import { FiEdit3 } from 'react-icons/fi';
import AddTalentPage from '../talents/AddTalentPage';

const AddDesigner = () => (
  <AddTalentPage
    category="designer"
    icon={<FiEdit3 />}
    titleKey="website.add_designer.title"
    subKey="website.add_designer.sub"
    listPath="/programmers?tab=designer"
  />
);

export default AddDesigner;
